import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  Alert,
  Button,
  ButtonGroup,
  Flex,
  FormField,
  FormHelp,
  Heading,
  Label,
  ModalDialog,
  spaceMixin,
  Textarea,
  TextButton,
} from '@zillow/constellation';
import CoapplicantSection from '../CoapplicantSection';
import { approveApplicationHeader } from '../InviteToMoveInManagerUtil';

const INVITATION_MAX_LENGTH = 500;

export const StyledAlert = styled(Alert)`
  margin-bottom: ${spaceMixin('sm')};
`;

export const StyledTextarea = styled(Textarea)`
  /* This is needed for the rows attribute. */
  &&& {
    height: auto;
  }
`;

const StyledFormField = styled(FormField)`
  width: 100%;
`;

export const StyledFormHelp = styled(FormHelp)`
  text-align: right;
`;

function InviteToMoveInInvitationModal({
  isOpen,
  onClose,
  emailText = '',
  invitationModalErrorMessage,
  handleEmailTextChange,
  sendInvitation,
}) {
  const isMaximumCharactersReached = emailText.length > INVITATION_MAX_LENGTH;

  return (
    <ModalDialog
      wide
      {...{
        isOpen,
        onClose,
        mediaQuery: {
          xs: { fullScreen: true },
          md: { fullScreen: false },
        },
        header: <Heading level={4}>{approveApplicationHeader}</Heading>,
        body: (
          <Flex display="flex" flexDirection="column" alignItems="center">
            {Boolean(invitationModalErrorMessage) && (
              <StyledAlert appearance="error" body={invitationModalErrorMessage} />
            )}
            <CoapplicantSection />
            {/* TODO: This should be a form for ADA compliance, but isn't because the submit button lives in the footer. */}
            {/* Consider using react-final-form, which can support this particular use case. */}
            <StyledFormField>
              <Label>Preview and customize your message:</Label>
              <StyledTextarea
                {...{
                  value: emailText,
                  onChange: handleEmailTextChange,
                  maxLength: INVITATION_MAX_LENGTH + 1,
                  error: isMaximumCharactersReached,
                  resize: 'vertical',
                  rows: '8',
                }}
              />
              <StyledFormHelp marginTop="xs" error={isMaximumCharactersReached}>
                {isMaximumCharactersReached ? 'Maximum characters reached' : 'Max characters: 500'}
              </StyledFormHelp>
            </StyledFormField>
          </Flex>
        ),
        footer: (
          <ButtonGroup aria-label="Send invitation actions">
            <TextButton onClick={onClose}>Cancel</TextButton>
            <Button
              className="zon_InviteToMoveInInvitation__SendButton"
              buttonType="primary"
              onClick={sendInvitation}
              disabled={isMaximumCharactersReached}
            >
              Send message
            </Button>
          </ButtonGroup>
        ),
      }}
    />
  );
}

InviteToMoveInInvitationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  emailText: PropTypes.string.isRequired,
  invitationModalErrorMessage: PropTypes.string,
  handleEmailTextChange: PropTypes.func.isRequired,
  sendInvitation: PropTypes.func.isRequired,
};

export default InviteToMoveInInvitationModal;
